import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Container,
  CssBaseline,
  Box,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const sections = [
  {
    title: 'What is the rooftop solar system cost per kW?',
    response: `Rooftop solar system cost per kW typically ranges from ₹45,000 to ₹85,000 in 2026. Your final solar panel price depends on technology, mounting structure, and inverter efficiency. With government subsidies and net metering benefits, many homeowners can recover this investment in 4–6 years through significantly lower power bills. <a href="https://www.vaysolar.com/docs/research/cost/" target="_blank" rel="noopener noreferrer">Learn more about solar costs</a>.`,
  },
  {
    title: 'How long does solar panel installation take?',
    response: `Solar panel installation timeline, from the initial site survey to the final commissioning, typically takes around 3–5 days for a residential project. Factors like system size and complexity can influence this, but efficient planning ensures a swift installation process. Our team manages all steps, including permits and grid connection, for a hassle-free experience. <a href="https://www.vaysolar.com/docs/blog/rooftop-solar-installation-process-in-new-delhi-step-by-step-guide/" target="_blank" rel="noopener noreferrer">View detailed installation guide</a>.`,
  },
  {
    title: 'Which is the best solar panel company in India?',
    response: `Identifying the best solar company in India depends on specific needs, but top solar panel company with strong reputations include Tata Power Solar, Adani Solar, and Vikram Solar. VaySolar only works with certified vendors with positive customer reviews, extensive experience, and comprehensive EPC (Engineering, Procurement, and Construction) services to ensure a reliable solar installation. <a href="https://www.vaysolar.com/docs/buying-guide/choose-installer/" target="_blank" rel="noopener noreferrer">Learn how to choose the right installer</a>.`,
  },
  {
    title: 'How can I claim the 2026 rooftop solar subsidy?',
    response: `To claim the 2026 rooftop solar subsidy under schemes like the MNRE rooftop scheme or PM Surya Ghar Yojana, you need to register on the national portal, choose an approved vendor, and follow the prescribed steps for system installation and net metering. Ensure you upload the required documents, and the subsidy amount will be credited to your bank account after inspection. <a href="https://www.vaysolar.com/docs/blog/rooftop-solar-subsidies-india-2025/" target="_blank" rel="noopener noreferrer">Read about subsidy details</a>.`,
  },
  {
    title: 'How does net metering work for rooftop solar systems?',
    response: `Net metering is a mechanism where your electricity meter credits you for any excess electricity generated by your rooftop solar systems and fed back into the utility grid. This bi-directional flow is measured, and you receive credit on your bill, effectively offsetting your consumption when your solar generation is lower. Net metering helps maximize savings and promotes efficient use of solar energy. <a href="https://www.vaysolar.com/docs/blog/group-virtual-net-metering-delhi-solar/" target="_blank" rel="noopener noreferrer">Learn more about net metering</a>.`,
  },
];

const FAQSection = () => {
  return (
    <Container style={{ padding: '0px' }}>
      <CssBaseline />
      <Typography variant='h5' gutterBottom sx={{ fontWeight: 'bold', pb: 3 }}>
        Frequently asked questions
      </Typography>
      <Box border={'1px solid #EBEBEB'} borderRadius={'9px'}>
        {sections.map((section, index) => (
          <Accordion
            key={index}
            sx={{
              '&:hover': {
                backgroundColor: '#f5f5f5',
                transition: 'background-color 0.3s ease',
              },
              '&.Mui-expanded': {
                backgroundColor: 'white',
                borderTop: index === 0 ? 'none' : '1px solid #EBEBEB',
              },
              boxShadow: 'none',
              '&.MuiAccordion-root': {
                borderRadius:
                  index === 0
                    ? '9px 9px 0 0'
                    : index === sections.length - 1
                      ? '0px 0px 9px 9px'
                      : '0px',
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              sx={{
                '&:hover': {
                  cursor: 'pointer',
                },
                '& .MuiAccordionSummary-content': {
                  transition: 'margin 0.2s ease',
                },
                '&.Mui-expanded': {
                  '& .MuiAccordionSummary-content': {
                    marginLeft: '8px',
                  },
                },
              }}
            >
              <Typography sx={{ fontWeight: 600 }}>{section.title}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{
                  padding: '8px',
                  lineHeight: 1.6,
                }}
                dangerouslySetInnerHTML={{ __html: section.response }}
              ></Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box>
    </Container>
  );
};

export default FAQSection;
